var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerBgCanalPedagogicoAcessibilidade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a39e00;}.cls-2{fill:#faff00;}.cls-3{fill:#ffffe6;}.cls-4{clip-path:url(#clippath);}.cls-5{fill:none;}.cls-6{fill:#eee2e4;}.cls-7{fill:#ffffb3;}.cls-8{fill:#cac200;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 1600,
    height: 180
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg_acessibilidade"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Group_107",
    className: "cls-6",
    points: "469.56 -285.48 214.13 182.79 1584.14 182.79 1633.92 91.53 1633.92 -285.48 469.56 -285.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_106",
    className: "cls-2",
    points: "-23.13 -25.71 -136.82 182.73 1615.59 182.73 1729.29 -25.71 -23.13 -25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_105",
    className: "cls-7",
    points: "90.42 -16.85 90.42 182.8 294.99 182.8 403.89 -16.85 90.42 -16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_103",
    className: "cls-1",
    points: "-125.55 -285.48 -125.55 182.79 201.6 182.79 457.03 -285.48 -125.55 -285.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_102",
    className: "cls-2",
    points: "-89.08 -293.48 -89.08 77.64 223.71 77.64 420.1 -293.48 -89.08 -293.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_99",
    className: "cls-3",
    points: "173.33 113.17 62.4 332.64 72.97 332.64 183.86 113.17 173.33 113.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_94",
    className: "cls-8",
    points: "189.58 -178.71 -2.06 172.62 -2.06 203.15 10.59 203.15 218.88 -178.71 189.58 -178.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_93",
    className: "cls-8",
    points: "144.57 -178.71 -2.06 90.12 -2.06 143.84 173.88 -178.71 144.57 -178.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Group_92",
    className: "cls-8",
    points: "99.57 -178.71 -2.06 7.61 -2.06 61.33 128.87 -178.71 99.57 -178.71"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBgCanalPedagogicoAcessibilidade);
export default __webpack_public_path__ + "static/media/banner_bg_canal_pedagogico_acessibilidade.65dfaf5ea5e919daf0f833a87faabfb0.svg";
export { ForwardRef as ReactComponent };